export function LatLngToWorldPoint(latLng) {
  var x = ((latLng.lng() + 180) / 360) * 256;
  var y =
    ((1 - Math.log(Math.tan((latLng.lat() * Math.PI) / 180) + 1 / Math.cos((latLng.lat() * Math.PI) / 180)) / Math.PI) / 2) *
    Math.pow(2, 0) *
    256;
  return { x, y };
}
